import PropTypes from 'prop-types';
import { Flex } from '@components/grid';
import { Icon } from '@components/icons';
import { P } from '@components/typography/new';

const MenuActionCard = ({ iconName, text, onClick, variant, ...rest }) => {
  if (variant === 'default') {
    return (
      <Flex
        onClick={onClick}
        background="white"
        py="15.5px"
        px="16px"
        borderRadius="8px"
        flex="1 1 auto"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        as="button"
        {...rest}
      >
        <Icon name={iconName} height="32px" width="32px" />
        <P variant="standard-semi-bold">{text}</P>
      </Flex>
    );
  }

  if (variant === 'fixed') {
    return (
      <Flex
        onClick={onClick}
        background="white"
        py="13.5px"
        px="16px"
        zIndex="50"
        position="fixed"
        width="100px"
        bottom="20px"
        right="20px"
        as="button"
        borderRadius="8px"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        {...rest}
      >
        <Icon name={iconName} height="32px" width="32px" />
        <P variant="standard-semi-bold">{text}</P>
      </Flex>
    );
  }

  return null;
};

MenuActionCard.propTypes = {
  iconName: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['fixed', 'default']),
};

MenuActionCard.defaultProps = {
  variant: 'default',
};

export default MenuActionCard;
